export default "__VITE_ASSET__BgqSJ_1K__"